import styled from 'styled-components'

import { Dropdown } from 'reactstrap'

export const DropdownWrapper = styled(Dropdown)`
  display: flex;
  align-items: center;
`
